import { render, staticRenderFns } from "./customerServiceControl.vue?vue&type=template&id=41c17342&scoped=true&"
import script from "./customerServiceControl.vue?vue&type=script&lang=js&"
export * from "./customerServiceControl.vue?vue&type=script&lang=js&"
import style0 from "./customerServiceControl.vue?vue&type=style&index=0&id=41c17342&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41c17342",
  null
  
)

export default component.exports